__turbopack_context__.v({
  "className": "roboto_48549564-module__Yj00la__className",
});
